import React from "react";
import { motion } from "framer-motion";
import { FaCertificate, FaShieldAlt, FaUsers, FaGem } from "react-icons/fa";

const certs = [
  {
    title: "ISO 9001:2015",
    label: "ISO Certified",
    icon: <FaCertificate />,
    desc: "Certified for international quality management standards."
  },
  {
    title: "100% Secure",
    label: "Trusted Quality",
    icon: <FaShieldAlt />,
    desc: "Rigorous safety testing for every door we manufacture."
  },
  {
    title: "Expert Craft",
    label: "Skilled Team",
    icon: <FaUsers />,
    desc: "Engineered by industry veterans with 20+ years experience."
  },
  {
    title: "Grade-A Wood",
    label: "Premium Materials",
    icon: <FaGem />,
    desc: "Sustainably sourced, high-density premium hardwoods."
  },
];

export default function Certifications() {
  return (
    <section style={{ background: "#ffffff" }}>
      <div className="container pt-3">
        
        {/* Header */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-1"
        >
          <h2 style={{ 
            fontWeight: "800", 
            fontSize: "2.5rem", 
            color: "#0F172A",
            letterSpacing: "-1px"
          }}>
            Certifications & <span style={{ color: "#F97316" }}>Partnerships</span>
          </h2>
          <p className="text-muted mx-auto" style={{ maxWidth: "600px" }}>
            Our commitment to excellence is backed by global standards and a relentless pursuit of quality.
          </p>
        </motion.div>

        {/* Grid */}
        <div className="row g-4 justify-content-center">
          {certs.map((item, i) => (
            <div className="col-6 col-md-3" key={i}>
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1, duration: 0.5 }}
                whileHover={{ 
                  y: -10,
                  transition: { duration: 0.2 }
                }}
                style={{
                  background: "#fff",
                  padding: "30px 20px",
                  borderRadius: "20px",
                  textAlign: "center",
                  border: "1px solid #f1f5f9",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.03)",
                  height: "100%",
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center"
                }}
              >
                {/* Badge Icon */}
                <motion.div
                  whileHover={{ rotateY: 180 }}
                  transition={{ duration: 0.6 }}
                  style={{
                    width: "60px",
                    height: "60px",
                    background: "#FFF7ED",
                    color: "#F97316",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "1.5rem",
                    marginBottom: "15px",
                    border: "2px dashed #F97316"
                  }}
                >
                  {item.icon}
                </motion.div>

                {/* Content */}
                <h6 style={{ 
                  fontWeight: "700", 
                  color: "#0F172A", 
                  marginBottom: "8px",
                  fontSize: "1.1rem" 
                }}>
                  {item.label}
                </h6>
                
                {/* Small Detail (Hidden on small mobile for space, shown on hover/desktop) */}
                <p style={{ 
                  fontSize: "0.85rem", 
                  color: "#64748b", 
                  lineHeight: "1.4",
                  margin: 0
                }}>
                  {item.title}
                </p>

                {/* Subtle Glow Effect on Hover */}
                <motion.div 
                  className="hover-line"
                  initial={{ width: 0 }}
                  whileHover={{ width: "40px" }}
                  style={{
                    height: "3px",
                    background: "#F97316",
                    marginTop: "15px",
                    borderRadius: "2px"
                  }}
                />
              </motion.div>
            </div>
          ))}
        </div>

        {/* Optional Logo Bar (For Partnerships) */}
        <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="mt-5 pt-5 border-top text-center"
        >
          
          
        </motion.div>

      </div>
    </section>
  );
}